const testimonials = [
  {
    name: '陈先生',
    role: '自由职业者',
    content: '之前一直用其他浏览器，换到91后发现速度真的快了很多。最满意的是广告拦截功能，看新闻终于不用被弹窗烦了。',
    rating: 5,
  },
  {
    name: '刘女士',
    role: '高校教师',
    content: '隐私保护做得很好，无痕模式下完全不担心留下痕迹。跨设备同步功能让我的电脑和手机无缝切换，太方便了。',
    rating: 5,
  },
  {
    name: '张同学',
    role: '研究生',
    content: '同时打开几十个论文页面都很流畅，标签分组功能简直是科研利器。而且界面简洁不花哨，用起来很舒服。',
    rating: 5,
  },
  {
    name: '王经理',
    role: 'IT部门主管',
    content: '从企业角度来说，91浏览器的安全性让我们很放心。恶意网站拦截准确率高，员工上网安全有保障。',
    rating: 5,
  },
];

export default function TestimonialSection() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block px-3.5 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold font-label mb-4">
            用户口碑
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            听听用户怎么说
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-base leading-relaxed">
            来自真实用户的使用体验，您的满意是我们最大的动力
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {testimonials.map((item) => (
            <div
              key={item.name}
              className="p-6 rounded-xl bg-background-100/70 border border-background-200/60"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: item.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm w-4 h-4 flex items-center justify-center"></i>
                ))}
              </div>
              <p className="text-foreground-700 leading-relaxed mb-4 text-sm">
                &ldquo;{item.content}&rdquo;
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-secondary-200 flex items-center justify-center">
                  <span className="text-secondary-700 font-semibold text-sm">{item.name[0]}</span>
                </div>
                <div>
                  <div className="font-medium text-foreground-900 text-sm">{item.name}</div>
                  <div className="text-xs text-foreground-500">{item.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}